export interface SearchRequestErrorElement {
	title: string
	message: string
}

export enum SearchRequestErrorType {
	'DESTINATION' = 'DESTINATION',
	'CALENDAR' = 'CALENDAR',
	'GUESTS' = 'GUESTS'
}
